module.exports = __webpack_public_path__ + "static/img/avatar04.f2dd257.png";


//////////////////
// WEBPACK FOOTER
// ./static/dist/img/avatar04.png
// module id = 1221
// module chunks = 5